import { capitalizeEachWord, isEmpty } from '~js/utils'
import gaEvents from '~js/ga-events'
import mixpanel from '@/plugins/mixpanel'
import visitorApi from '@/services/api/visitor'
import PANORAMA_GA from '@/utils/hardcode'
import { sendMessage } from '@/utils/postMessage'

const state = {
  isMarkerInfoActive: false,
  markerInfoData: {}
}

export const getters = {
  isMarkerInfoActive: state => state.isMarkerInfoActive,
  markerInfoData: state => state.markerInfoData
}

export const actions = {
  showMarkerInfo ({ commit, state }) {
    if (state.isMarkerInfoActive === false) {
      commit('SET_MARKER_INFO_ACTIVE', true)
      // gaEvents.sendEvent('Marker', 'ShowMarkerInfo', state.markerInfoData.objectId)
    }
  },

  toggleMarkerInfo ({ dispatch, state }) {
    if (state.isMarkerInfoActive === true) {
      dispatch('closeMarkerInfo')
    } else {
      dispatch('showMarkerInfo')
    }
  },

  closeMarkerInfo ({ commit, state }) {
    if (state.isMarkerInfoActive === true) {
      commit('SET_MARKER_INFO_ACTIVE', false)
      // gaEvents.sendEvent('Marker', 'CloseMarkerInfo', state.markerInfoData.objectId)
    }
  },

  setMarkerInfoData ({ commit, rootState }, marker = {}) {
    commit('SET_MARKER_INFO_DATA', marker)
    marker = { ...marker }
    if (!isEmpty(marker)) {
      if (marker.type === 'tag') {
        gaEvents.sendEvent('Marker', 'TagClicks', marker.objectId)
      } else if (marker.type === 'memo') {
        gaEvents.sendEvent('Marker', 'MemoClicks', marker.objectId)
      } else if (marker.type === 'gallery') {
        gaEvents.sendEvent('Marker', 'GalleryClicks', marker.objectId)
      } else if (marker.type === 'multitag') {
        gaEvents.sendEvent('Marker', 'MultitagClicks', marker.objectId)
        // Find multi tag name
        if (Array.isArray(marker.multitagInfo)) {
          const items = marker.multitagInfo.filter(tag => !tag.hidden)
          let item = items.find(item => item.mainPhoto)
          if (item) {
            marker.name = item.name
          } else {
            item = items[0]
            if (item) {
              marker.name = item.name
            }
          }
        }
      }
      if (marker.type === 'tag' || marker.type === 'multitag') {
        const currentPanoramaName = rootState.panoramas.panoramas.find(panorama => panorama.objectId === marker.panoramaId)?.customCategory.trim()
        if (currentPanoramaName) {
          const isIndoor = PANORAMA_GA.indoor.includes(currentPanoramaName)
          if (isIndoor) {
            sendMessage({
              iStagingDataLayerEvent: {
                sfccEvent: true,
                event: 'virtual_tour_boutique_stars',
                boutique_category: capitalizeEachWord(currentPanoramaName),
                cta_name: capitalizeEachWord(marker.name)
              }
            })
          } else {
            sendMessage({
              iStagingDataLayerEvent: {
                sfccEvent: true,
                event: 'virtual_tour_star_click',
                current_location: capitalizeEachWord(currentPanoramaName),
                cta_name: capitalizeEachWord(marker.name)
              }
            })
          }
        }
      }
      mixpanel.track('Click Marker', {
        buildingId: marker.buildingId,
        objectId: marker.objectId,
        type: marker.type,
        name: marker.name
      })
      visitorApi.addClickCount(marker.objectId)
    }
  }
}

export const mutations = {
  SET_MARKER_INFO_ACTIVE (state, bool = false) {
    state.isMarkerInfoActive = bool
  },

  SET_MARKER_INFO_DATA (state, marker = {}) {
    state.markerInfoData = marker
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
